import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { routerNavigationAction } from "@ngrx/router-store";
import { Store } from "@ngrx/store";
import { OidcSecurityService } from "angular-auth-oidc-client";
import * as _ from "lodash";
import { filter, switchMap, tap } from "rxjs/operators";

import { AccountStatus } from "../../definitions/account-status";
import { ClockService } from "../../services/clock.service";
import { SessionRefreshed } from "../actions/user.actions";
import { UserState } from "../models/user-state";
import { AppState } from "../reducers";

@Injectable()
export class RouterEffects {
	pageNavigation = createEffect(
		() =>
			this.actions.pipe(
				ofType(routerNavigationAction),
				switchMap(() => this.oidcSecurityService.getAccessToken()),
				tap((token) => {
					this.store.dispatch(this.buildSessionRefreshAction(token));
				})
			),
		{ dispatch: false }
	);

	sessionRefreshed = createEffect(
		() =>
			this.actions.pipe(
				ofType(SessionRefreshed),
				filter(
					(userState) =>
						userState.userState?.auth &&
						!_.includes(AccountStatus.DENIED_STATUSES, userState?.userStatus?.status) &&
						!_.includes(
							AccountStatus.DISABLED_STATUSES,
							userState?.userStatus?.status
						) &&
						!_.includes(
							AccountStatus.PENDING_USER_STATUSES,
							userState?.userStatus?.status
						) &&
						!_.includes(AccountStatus.PENDING_STATUSES, userState?.userStatus?.status)
				),
				tap(() => {
					this.clockService.start();
				})
			),
		{ dispatch: false }
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private clockService: ClockService,
		private oidcSecurityService: OidcSecurityService
	) {}

	private buildSessionRefreshAction(token: string) {
		const userId = sessionStorage.getItem("currentUser");
		let userStatus = null;
		try {
			const rawUserStatus = sessionStorage.getItem("userStatus");
			if (rawUserStatus) {
				userStatus = JSON.parse(rawUserStatus);
			}
		} catch (e) {
			console.debug("Failed to parse userStatus from session", e);
		}

		const isSessionValid = userId && token && !_.isEmpty(userStatus);

		if (!isSessionValid) {
			console.log("No valid session found, skipping SessionRefreshed action");
			return { type: "[Router] No Session Available" };
		}

		const strRoles = sessionStorage.getItem("roles");
		let roles: string[];
		if (strRoles) {
			roles = strRoles.split(",");
		}

		const loading = false;
		const userState: UserState = { auth: true, roles, userId, loading };
		return SessionRefreshed({ userState, userStatus });
	}
}
